import React, { useRef } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import '@toast-ui/chart/dist/toastui-chart.min.css';
import { LineChart } from '@toast-ui/react-chart';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Shared/Css/WatchChart.css';
import nb01 from '../img/weather/NB01.png'; //맑음
import nb01_n from '../img/weather/NB01_N.png'; //밤맑음
import nb02_n from '../img/weather/NB02_N.png'; //밤구름
import nb03 from '../img/weather/NB03.png'; //구름많음
// import nb03_n from '../img/weather/NB03_N.png' //밤구름많음
import nb04 from '../img/weather/NB04.png'; //흐림
import nb07 from '../img/weather/NB07.png'; //소나기
import nb08 from '../img/weather/NB08.png'; //비
import nb11 from '../img/weather/NB11.png'; //눈
import nb12 from '../img/weather/NB12.png'; //비 또는 눈

function WatchChart(props) {
  const chartRef = useRef();
  //날짜라이브러리
  dayjs.locale('ko');

  const data = {
    categories: props.statedata.map(
      (row) =>
        dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format('MM/DD') +
        dayjs(dayjs(row.FcstTime, 'HHmm').toDate()).format('Ahh') +
        '시'
    ),
    series: [
      {
        name: '온도',
        data: props.statedata.map((row) => Number(row.FcstValue_tmp)),
      },
      {
        name: '습도',
        data: props.statedata.map((row) => Number(row.FcstValue_reh)),
      },
    ],
  };
  //colSpan1번째 날짜 처리
  let namesArr = {};
  const colSpan = props.statedata.reduce((result, item, key) => {
    if (namesArr[item.FcstDate] === undefined) {
      namesArr[item.FcstDate] = key;
      result[key] = 1;
    } else {
      const firstIndex = namesArr[item.FcstDate];
      if (
        firstIndex === key - 1 ||
        (item.FcstDate === props.statedata[key - 1].FcstDate &&
          result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 1;
        namesArr[item.FcstDate] = key;
      }
    }
    return result;
  }, []);
  //colSpan2번째 날짜 처리
  let namesArr01 = {};
  const colSpan01 = props.statedata.reduce((result, item, key) => {
    if (namesArr01[item.FcstDate] === undefined) {
      namesArr01[item.FcstDate] = key;
      result[key] = 1;
    } else {
      const firstIndex = namesArr[item.FcstDate] + 1;
      if (
        firstIndex === key - 1 ||
        (item.FcstDate === props.statedata[key - 1].FcstDate &&
          result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 100;
        namesArr01[item.FcstDate] = key;
      }
    }
    return result;
  }, []);

  //console.log(colSpan01)

  const datarain = props.statedata.map((row, index) => {
    return (
      <div key={index}>
        <table className="wtable">
          <thead>
            <tr>
              {colSpan[index] > 0 ? (
                <th className="wtdheight-h00" colSpan={colSpan[index]}>
                  {dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format(
                    'MM/DD'
                  )}
                </th>
              ) : colSpan01[index] > 100 &&
                dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format(
                  'ddd'
                ) === '토' ? (
                <th className="wtdheight-h01" colSpan={colSpan01[index]}>
                  {dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format(
                    'ddd'
                  )}{' '}
                </th>
              ) : colSpan01[index] > 100 &&
                dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format(
                  'ddd'
                ) === '일' ? (
                <th className="wtdheight-h02" colSpan={colSpan01[index]}>
                  {dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format(
                    'ddd'
                  )}{' '}
                </th>
              ) : colSpan01[index] > 100 ? (
                <th className="wtdheight-h03" colSpan={colSpan01[index]}>
                  {dayjs(dayjs(row.FcstDate, 'YYYYMMDD').toDate()).format(
                    'ddd'
                  )}{' '}
                </th>
              ) : (
                <th className="wtdheight-h04" colSpan={colSpan[index]}>
                  {}
                </th>
              )}
            </tr>
          </thead>
          <tbody className="abcd">
            <tr className="wtr">
              <td
                className="wtd wtdheight-h1"
                style={
                  row.FcstDate === dayjs().format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : row.FcstDate === dayjs().add(1, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#e1f5fe' }
                    : row.FcstDate === dayjs().add(2, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fffacd' }
                    : row.FcstDate === dayjs().add(3, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : null
                }
              >
                {dayjs(dayjs(row.FcstTime, 'HHmm').toDate()).format('A hh') +
                  '시'}
              </td>
            </tr>
            <tr className="wtr">
              <td
                className="wtd wtdheight-h2"
                style={
                  row.FcstDate === dayjs().format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : row.FcstDate === dayjs().add(1, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#e1f5fe' }
                    : row.FcstDate === dayjs().add(2, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fffacd' }
                    : row.FcstDate === dayjs().add(3, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : null
                }
              >
                {row.FcstTime === '0600' ||
                row.FcstTime === '0700' ||
                row.FcstTime === '0800' ||
                row.FcstTime === '0900' ||
                row.FcstTime === '1000' ||
                row.FcstTime === '1100' ||
                row.FcstTime === '1200' ||
                row.FcstTime === '1300' ||
                row.FcstTime === '1400' ||
                row.FcstTime === '1500' ||
                row.FcstTime === '1600' ||
                row.FcstTime === '1700' ||
                row.FcstTime === '1800' ||
                row.FcstTime === '1900' ? (
                  //className="fas fa-sun"
                  // {row.FcstValue_pty}
                  row.FcstValue_pty === '비없음' &&
                  row.FcstValue_sky === '맑음' ? (
                    <img
                      src={nb01}
                      style={{
                        width: '60px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : row.FcstValue_pty === '비없음' &&
                    row.FcstValue_sky === '구름많음' ? (
                    <img
                      src={nb03}
                      style={{
                        width: '60px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : row.FcstValue_pty === '비없음' &&
                    row.FcstValue_sky === '흐림' ? (
                    <img
                      src={nb04}
                      style={{
                        width: '60px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : row.FcstValue_pty === '비' ? (
                    <img
                      src={nb08}
                      style={{
                        width: '60px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : row.FcstValue_pty === '비/눈' ? (
                    <img
                      src={nb12}
                      style={{
                        width: '50px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : row.FcstValue_pty === '눈' ? (
                    <img
                      src={nb11}
                      style={{
                        width: '60px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : row.FcstValue_pty === '소나기' ? (
                    <img
                      src={nb07}
                      style={{
                        width: '60px',
                        height: '40px',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  ) : null
                ) : row.FcstValue_pty === '비없음' &&
                  row.FcstValue_sky === '맑음' ? (
                  <img
                    src={nb01_n}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : row.FcstValue_pty === '비없음' &&
                  row.FcstValue_sky === '구름많음' ? (
                  <img
                    src={nb02_n}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : row.FcstValue_pty === '비없음' &&
                  row.FcstValue_sky === '흐림' ? (
                  <img
                    src={nb04}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : row.FcstValue_pty === '비' ? (
                  <img
                    src={nb08}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : row.FcstValue_pty === '비/눈' ? (
                  <img
                    src={nb12}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : row.FcstValue_pty === '눈' ? (
                  <img
                    src={nb11}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : row.FcstValue_pty === '소나기' ? (
                  <img
                    src={nb07}
                    style={{
                      width: '60px',
                      height: '40px',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                ) : null}
              </td>
            </tr>
            <tr className="wtr">
              <td
                className="wtd wtdheight-h3"
                style={
                  row.FcstDate === dayjs().format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : row.FcstDate === dayjs().add(1, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#e1f5fe' }
                    : row.FcstDate === dayjs().add(2, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fffacd' }
                    : row.FcstDate === dayjs().add(3, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : null
                }
              >
                {row.FcstValue_pty === '비없음' ? (
                  <div style={{ fontSize: '12px', color: '#26a69a' }}>
                    비없음
                  </div>
                ) : row.FcstValue_pty === '비' ? (
                  <div
                    style={{
                      fontSize: '14px',
                      color: '#f50057',
                      fontWeight: 800,
                    }}
                  >
                    비
                  </div>
                ) : row.FcstValue_pty === '비/눈' ? (
                  <div style={{ fontSize: '14px', color: 'blue' }}>비/눈</div>
                ) : row.FcstValue_pty === '눈' ? (
                  <div style={{ fontSize: '14px', color: 'blue' }}>눈</div>
                ) : row.FcstValue_pty === '소나기' ? (
                  <div
                    style={{
                      fontSize: '14px',
                      color: '#ff5252',
                      fontWeight: 800,
                    }}
                  >
                    소나기
                  </div>
                ) : null}
              </td>
            </tr>
            <tr className="wtr">
              <td
                className="wtd wtdheight-h4"
                style={
                  row.FcstDate === dayjs().format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : row.FcstDate === dayjs().add(1, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#e1f5fe' }
                    : row.FcstDate === dayjs().add(2, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fffacd' }
                    : row.FcstDate === dayjs().add(3, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : null
                }
              >
                {row.FcstValue_reh <= 55 ? (
                  <div style={{ fontSize: '14px' }}>{row.FcstValue_reh}%</div>
                ) : row.FcstValue_reh <= 70 ? (
                  <div style={{ fontSize: '14px', color: 'darkorange' }}>
                    {row.FcstValue_reh}%
                  </div>
                ) : row.FcstValue_reh >= 71 ? (
                  <div style={{ fontSize: '14px', color: 'red' }}>
                    {row.FcstValue_reh}%
                  </div>
                ) : null}
              </td>
            </tr>
            <tr className="wtr">
              <td
                className="wtd wtdheight-h5"
                style={
                  row.FcstDate === dayjs().format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : row.FcstDate === dayjs().add(1, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#e1f5fe' }
                    : row.FcstDate === dayjs().add(2, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fffacd' }
                    : row.FcstDate === dayjs().add(3, 'd').format('YYYYMMDD')
                    ? { backgroundColor: '#fbe9e7' }
                    : null
                }
              >
                {row.FcstValue_tmp <= 26 ? (
                  <div style={{ fontSize: '14px' }}>{row.FcstValue_tmp}℃</div>
                ) : row.FcstValue_tmp <= 29 ? (
                  <div style={{ fontSize: '14px', color: 'darkgoldenrod' }}>
                    {row.FcstValue_tmp}℃
                  </div>
                ) : row.FcstValue_tmp <= 31 ? (
                  <div style={{ fontSize: '14px', color: 'darkorange' }}>
                    {row.FcstValue_tmp}℃
                  </div>
                ) : row.FcstValue_tmp >= 32 ? (
                  <div style={{ fontSize: '14px', color: 'red' }}>
                    {row.FcstValue_tmp}℃
                  </div>
                ) : null}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  });

  //console.log(datarain)
  //console.log(data.series.data)

  const options = {
    _xAxis: {
      title: '날자시간',
    },
    get xAxis() {
      return this._xAxis;
    },
    set xAxis(value) {
      this._xAxis = value;
    },
    yAxis: [
      {
        title: '온도(°C)',
      },
      {
        title: '습도(%)',
        scale: {
          min: 0,
          max: 100,
        },
      },
    ],

    // tooltip: {
    //   formatter1: (value) => `${value}°C`,
    // },
    exportMenu: {
      visible: false,
    },

    legend: {
      //align: 'bottom',
      visible: false, //표시안함
    },
    series: {
      dataLabels: {
        lineWidth: 1,
        visible: true,
        spline: true,
        offsetY: -12,
      },
      //zoomable: true,
      showLabel: true,
      showDot: true,
      eventDetectType: 'grouped',
    },
    //theme,
  };

  const containerStyle = {
    width: '1220px',
    height: '250px',
    // border: "1px solid red"
  };

  return (
    <>
      <div style={{ overflowX: 'auto', overflowY: 'hidden' }}>
        <LineChart
          ref={chartRef}
          data={data}
          options={options}
          style={containerStyle}
        />
      </div>
      <div className="wcontainer">{datarain}</div>
    </>
  );
}

export default WatchChart;
